<template>
  <el-tooltip effect="dark" :content="text" placement="top" popper-class="text-omit-tooltip">
    <span class="text-omit">{{ text }}</span>
  </el-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * 省略表示コンポーネント
 * ツールチップでも出す
 */
export default defineComponent({
  name: 'TextOmit',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
span {
  width: 100%;
  display: inline-block;
}
</style>
